// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3yTJb","Logo":"Toolbar_Logo__pEB0r","DesktopOnly":"Toolbar_DesktopOnly__2bNbs"};